import i18n from './lang'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as Vue from 'vue' // in Vue 3
import axios from 'axios'
import VueAxios from 'vue-axios'
//字体图标库
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
//element ui


library.add(faUserSecret, fab)
createApp(App).use(store).use(router).use(VueAxios, axios).use(i18n).component("font-awesome-icon", FontAwesomeIcon).mount('#app')